import { render, staticRenderFns } from "./UserPage.vue?vue&type=template&id=57be0ebe&scoped=true&"
import script from "./UserPage.vue?vue&type=script&lang=js&"
export * from "./UserPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57be0ebe",
  null
  
)

export default component.exports